// export const endPoint = "https://qbmedia.b-cdn.net/lagelato"
export const endPoint = "https://qbmedia.b-cdn.net/angel"
export const url = "https://qbmedia.b-cdn.net/angel"

export const bizNUM = '972527587447'
export const bizNUM2 = '04123123'
export const bizFB = 'angel'
export const bizIG = 'angel_shivuk'
export const bizWEB = 'https://angel-shivuk.com'


// ### App Colors ###


// footer bottom nav
export const footerBottomNav = "#02B7ED"
export const footerBottomNavHover = "#FFE395"

// header
export const headerBGC = "#F8D100"

// footer
export const footerBGC = "#137EAD"
export const footerAcolor = "#F8D104"
export const footerQBcolor = "#ffffff"

// body colors
export const bodyText = "#0A1A19"
export const bodyBg = "#D3E5F2"
export const cardBtns = "#238C44"

// product default image
export const defaultImage = "default.webp"

const emojiRanges = [
  [0x1F000, 0x1FAFF],
  [0x1F900, 0x1F9FF],
  [0x2600, 0x27BF],
];

const isEmojiCodePoint = (codePoint) =>
  emojiRanges.some(([start, end]) => codePoint >= start && codePoint <= end);

export const getCategorySlug = (name = '') => {
  if (!name) return '';
  const chars = Array.from(name.trim());

  while (chars.length) {
    const last = chars[chars.length - 1];
    const codePoint = last.codePointAt(0);

    if (last === '️' || last === '‍') {
      chars.pop();
      continue;
    }

    if (isEmojiCodePoint(codePoint)) {
      chars.pop();
      continue;
    }

    break;
  }

  return chars.join('').trim();
};